import NextLink from 'next/link';

// pages/500.js
export default function Custom500({ errorCode, errorMessage }: { errorCode: number; errorMessage: string }) {
  return (
    <div className="flex h-screen flex-col items-center justify-center gap-10 px-6 py-20 md:px-10 md:py-[88px] lg:px-[272px] lg:py-[136px]">
      <h1 className="text-[100px] font-bold">{errorCode}</h1>
      {errorCode === 404 ? (
        <h1 className="text-5xl">Page not found</h1>
      ) : errorCode === 401 ? (
        <h1 className="text-5xl">Authentication failed. Please try again.</h1>
      ) : (
        <h1 className="text-5xl">Whoops, Something Went Wrong</h1>
      )}

      <NextLink href="/" className="underline">
        Home page
      </NextLink>

      <div className="text-center">
        <p className="font-gotham font-n-light mb-4 text-sm leading-4 text-black/50 md:mb-3">Sorry</p>
        <p className="font-gotham font-s-light tracking-paragraph md:text-desktop-small text-base text-black/75 md:leading-8">
          {errorMessage}
        </p>
      </div>
    </div>
  );
}
